import React from "react"

import styles from "./Introduction2.module.scss";
import ImageText from "./Elements/ImageText";

import src01 from "../images/intro_01.jpg";
import src01Ret from "../images/intro_01@2x.jpg";
import webp01 from "../images/intro_01.webp";
import webp01Ret from "../images/intro_01@2x.webp";

import Content from "./Elements/Content";
import Highlight from "./Elements/Highlight";

export default function Introduction2 () {

    return (
        <Content classname={styles.Main}>
            <div className="container">
                <Highlight color={'darkblue'} classname={['full', styles.Luxe].join(' ')}>
                  <p className={'size-7 ml-2'}>
                      La « cinquième génération de télécommunication mobile», en d’autres termes la 5G, n'est pas une évolution, c'est une révolution… Cette « punchline » souvent entendue dans les conférences de presse et les salons dédiés à la téléphonie mobile pourrait rapidement prendre tout son sens : non seulement la 5G va débrider les vitesses de connexion en les multipliant par 10, mais elle va aussi considérablement réduire le fameux temps de latence qui correspond à la période qui s’écoule entre le moment où l'utilisateur agit sur le clavier et sa traduction à l’écran : il devrait passer de 10 ms en 4G à 1 ms en 5G.
                  </p>

                  <ImageText image={{src: src01, srcRet: src01Ret, webp: webp01, webpRet: webp01Ret}} radius={false}>
                      <p>
                          L’accélérateur 5G est donc bien en marche pour les entreprises et les particuliers : une vraie révolution "à distance" pour les années qui viennent… Car l’autre avantage de cette technologie passe par l’acceptation d’une plus grande densité d’appareils connectés au m2 sans subir de phénomène de saturation. On estime ainsi que la 5G pourrait permettre de multiplier par près de 10 la densité de connexion actuelle, ce qui donnerait une prise en charge théorique allant « jusqu’à un million d’appareils connectés par mètre carré ».
                      </p>

                      <p>
                          Au-delà des chiffres bruts, cette amélioration de la connectivité va offrir de nouvelles perspectives aux utilisateurs et pas seulement aux fans de jeux vidéo et aux adeptes du cloud gaming ! Pour les spécialistes, il s’agit ni plus ni moins d’un changement de paradigme : en effet, la réduction du temps de latence va accélérer l’apparition de nouveaux types d’objets connectés et développer de façon spectaculaire l’usage de la réalité augmentée : Metavers, cloud, big data, objets connectés, smart city, voitures autonomes, télémédecine… autant de domaines qui vont connaitre un véritable coup d’accélérateur grâce à la technologie 5G !
                      </p>
                  </ImageText>
                </Highlight>

            </div>
        </Content>
    )
}
